var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "container",
    staticClass: "default-layout-container",
    class: {
      stretch: _vm.isStretchContent
    }
  }, [_c('div', {
    staticClass: "layout-title"
  }, [_vm._t("title")], 2), _c('div', {
    staticClass: "layout-content"
  }, [_vm._t("content")], 2), _c('div', {
    staticClass: "layout-footer"
  }, [_vm._t("footer")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }